import React from "react";
import IndexPage from "./index";
import AboutPage from "./about";
import FaqPage from "./faq";
import ContactPage from "./contact";
import PricingPage from "./pricing";
import DashboardPage from "./dashboard";
import AuthPage from "./auth";
import SettingsPage from "./settings";
import LegalPage from "./legal";
import ResourcesPage from "./resources";
import ExercisesPage from "./exercises";
import { Switch, Route, Router } from "./../util/router";
import PurchasePage from "./purchase";
import FirebaseActionPage from "./firebase-action";
import NotFoundPage from "./404";
import Footer from "./../components/Footer";
import "./../util/analytics";
import { AuthProvider } from "./../util/auth";
import { ThemeProvider } from "./../util/theme";
import { QueryClientProvider } from "./../util/db";
import bookappt from "./bookappt";
import bookappt2 from "./bookappt2";
import biometricinfo from "./biometricinfo";
import Steps from "./steps";
import { FormProvider } from "../util/context";
import FinalStep from "../components/FinalStep";

function App(props) {
  return (
    <QueryClientProvider>
      <ThemeProvider>
        <AuthProvider>
          <FormProvider>
            <Router>
              <>
                <Switch>
                  <Route exact path="/" component={IndexPage} />

                  <Route exact path="/about" component={AboutPage} />

                  <Route exact path="/faq" component={FaqPage} />

                  <Route exact path="/contact" component={ContactPage} />

                  <Route exact path="/pricing" component={PricingPage} />

                  <Route exact path="/dashboard" component={DashboardPage} />

                  <Route exact path="/auth/:type" component={AuthPage} />

                  <Route exact path="/moreinfo" component={FinalStep} />

                  <Route
                    exact
                    path="/biometricinfo"
                    component={biometricinfo}
                  />

                  <Route exact path="/bookappt" component={bookappt} />

                  <Route exact path="/bookappt2" component={bookappt2} />

                  <Route exact path="/steps" component={Steps} />

                  <Route
                    exact
                    path="/settings/:section"
                    component={SettingsPage}
                  />

                  <Route exact path="/legal/:section" component={LegalPage} />

                  <Route exact path="/resources" component={ResourcesPage} />

                  <Route exact path="/exercises" component={ExercisesPage} />

                  <Route
                    exact
                    path="/purchase/:plan"
                    component={PurchasePage}
                  />

                  <Route
                    exact
                    path="/firebase-action"
                    component={FirebaseActionPage}
                  />

                  <Route component={NotFoundPage} />
                </Switch>

                <Footer
                  bgColor="default"
                  size="medium"
                  bgImage=""
                  bgImageOpacity={1}
                  copyright={`© ${new Date().getFullYear()} Parados Cerebral Solutions Inc.`}
                  logo="https://drive.google.com/uc?export=view&id=1idL8ixbXPQ6cFrmYenBkUfmz2X9_MkFi"
                  logoInverted="https://drive.google.com/uc?export=view&id=1FDW3ksZ8tqRXneFsRPHFN4Gor8X1kfEA"
                  sticky={true}
                />
              </>
            </Router>
          </FormProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
